type ResolveSlugOptions = {
  slug?: string | null;
  anchorId?: string;
  effectiveDate?: string | null;
  parentSlug?: string | null;
};

export function resolveSlug(type: string, options: ResolveSlugOptions = {}) {
  const { slug, anchorId, effectiveDate, parentSlug } = options;
  let resolvedSlug = {
    page: `/${slug}`,
    blog: `/blog`,
    post: `/blog/${slug}`,
    author: `/blog/author/${slug}`,
    caseStudy: `/case-studies/${slug}`,
    caseStudyCategory: `/case-studies/categories/${slug}`,
    caseStudies: `/case-studies`,
    blogCategory: `/blog/categories/${slug}`,
    resources: `/resources`,
    resource: `/resources/${slug}`,
    resourceCategory: `/resources/categories/${slug}`,
    events: `/events`,
    event: `/events/${slug}`,
    glossaryTerm: `/glossary/${slug}`,
    glossary: `/glossary`,
    integration: `/integrations/${slug}`,
    integrations: `/integrations`,
    legalIndex: `/legal`,
    legalDocument: `/legal/${slug}`,
    legalDocumentVersion:
      slug && effectiveDate ? `/legal/${slug}/${effectiveDate}` : undefined,
    accountCampaign: `/for/${slug}`,
    accountPage: parentSlug && slug ? `/for/${parentSlug}/${slug}` : undefined,
  }[type];

  if (!resolvedSlug) return resolvedSlug;

  if (anchorId) {
    resolvedSlug += `#${anchorId}`;
  }

  return resolvedSlug;
}
